export default __webpack_public_path__ + "static/media/total-amount.4483f7d7.svg";